import { render, staticRenderFns } from "./conferimadddatacomponents.vue?vue&type=template&id=8b5bc51c"
import script from "./conferimadddatacomponents.vue?vue&type=script&lang=js"
export * from "./conferimadddatacomponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports